import { Routes, mapToCanActivate, mapToCanDeactivate } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { DeliveryItemComponent } from './components/delivery-item/delivery-item.component';
import { DeliveryOverviewComponent } from './components/delivery-overview/delivery-overview.component';
import { DeliveryComponent } from './delivery.component';
import { PendingBalanceGuard } from '../cycle/guards/pending-balance.guard';

export const deliveryRoutes: Routes = [
  {
    path: 'delivery',
    component: DeliveryComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    children: [
      {
        path: '',
        component: DeliveryOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'delivery-overview' },
      },
      {
        path: ':deliveryId',
        component: DeliveryItemComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        canDeactivate: mapToCanDeactivate([PendingBalanceGuard]),
        data: { name: 'delivery-item' },
      },
    ],
  },
];
